<template>
  <div class="content">
    <!--  -->
    <el-row style="height:3vh;padding-left: 0.5vw;padding-top: 0.1vh;">
      <el-col :span="24">
        <div class="grid-content bg-purple-dark">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>设备管理</el-breadcrumb-item>
            <el-breadcrumb-item>用电设备记录</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </el-col>
    </el-row>
    <!-- 主体 --> 
    <el-container style="height:calc(100% - 3vh);width:100%;position: relative;">
      <!-- 侧边树 -->
      <!-- <el-aside width="16%" style="height:100%" class="aside">
        <el-card style="height:100%;overflow-y: auto;">
          <el-tree
            :data="dataTree"
            ref="tree"
            :props="defaultProps"
            default-expand-all
            :expand-on-click-node="false"
            :highlight-current="true"
            @node-click="handleNodeClick"
            node-key="equipType"
            :current-node-key="currentNodekey"
            :default-expanded-keys="expandedkeys"
          >  
          </el-tree>
        </el-card>
      </el-aside> -->
      <!-- 右边 -->
      <el-main
        class="build-CURD"
        style="height: 100%;padding:0px !important; padding-left: 20px !important; position: relative;width: 100%;"
      >
        <el-card class="box-card box-card_right" style="height:100%;padding:0px !important">
          <!-- 搜索框上 -->
          <!-- <el-row :gutter="20" type="flex" justify="space-between"> -->
          <!-- <el-col :span="6"> -->
          <div
            style=" margin: 10px 20px;display:flex;align-items: center;height:60px"
          >  
          <!-- <div class="grid-search">
            <span>类型:</span>
             <el-select v-model="search.equipType" clearable  @change="doFilter" placeholder="请选择">
              <el-option
                v-for="item in dataTree"
                :key="item.equipType"
                :label="item.name"
                :value="item.equipType"
                 >
              </el-option>
            </el-select>
          </div> -->
          <div class="grid-search">
            <el-input v-model="search.username" placeholder="请输入人员名称"  clearable @input="doFilter">
              <el-button slot="append" icon="el-icon-search"></el-button>
            </el-input>
          </div>
             <div class="grid-search">
              <el-input v-model="search.sn" placeholder="请输入设备sn号"  clearable @input="doFilter">
                <el-button slot="append" icon="el-icon-search"></el-button>
              </el-input>
             </div>
          </div>
          <div class="build-table">
            <el-table :data="listData" height="100%" style="width: 100%;" stripe :header-cell-style="{background:'#F5F7F9',color:'#909399'}">
              <template slot="empty">
                <p>{{dataText}}</p>
              </template>
              <!-- <el-table-column type="selection" width="55"></el-table-column> -->
              <el-table-column label="序号" width="80">
                <template slot-scope="scope">
                  <a>{{ scope.row.index}}</a>
                </template>
              </el-table-column>
              <el-table-column label="设备类型">
                <template slot-scope="scope">
                  <a  v-if="scope.row.useType=='1'">雾炮</a>
                  <a  v-if="scope.row.useType=='2'">喷淋</a>
                  <a  v-if="scope.row.useType=='3'">照明</a>
                </template>
              </el-table-column>
               <el-table-column label="设备状态">
                <template slot-scope="scope">
                  <a  v-if="scope.row.equipFlagName=='开启'" style="color: #409eff;">{{scope.row.equipFlagName }}</a>
                  <a  v-else style="color: #f00;">{{scope.row.equipFlagName }}</a>
                </template>
              </el-table-column>
              <el-table-column label="操作状态">
                <template slot-scope="scope">
                  <a  v-if="scope.row.opFlagName=='成功'" style="color: #85ce61;">{{scope.row.opFlagName }}</a>
                  <a  v-else style="color: #ebb563;">{{scope.row.opFlagName }}</a>
                </template>
              </el-table-column>
              <el-table-column label="控制方式">
                <template slot-scope="scope">
                  <a>{{ scope.row.operationName}}</a>
                </template>
              </el-table-column>
              <el-table-column label="操作人员">
                <template slot-scope="scope">
                  <span>{{ scope.row.username }}</span>
                </template>
              </el-table-column>
             <el-table-column label="操作时间" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                  <span>{{ scope.row.createDate }}</span>
                </template>
              </el-table-column>
              <el-table-column label="设备号" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                  <span>{{ scope.row.sn }}</span>
                </template>
              </el-table-column>
            </el-table>
             <!-- 分页展示 -->
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[5, 10, 20, 50]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalItems"
            ></el-pagination>
          </div>
        </el-card>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import myHttp from '../../../untils/port.js'
import util from '../../../untils/util.js'
import base from '../../../untils/base'
export default {
  data() {
    return {
      // dataTree: [{name:'喷淋',equipType:'1'},{name:'雾炮',equipType:'2'},{name:'照明',equipType:'3'}],
      listData: [],
      search: {
        sn:'',
        equipType:'3',
        username:''
        //查询
      },
      classId: '', //班组id
      // currentPage: 1,
      // pageSize: 10,
      // totalItems: 0,
      dataText: '数据加载中...',
      // defaultProps: {
      //   children: 'children',
      //   label: 'name'
      // },
      // currentNodekey: '', //默认选中的节点树
      // expandedkeys: [], //默认展开的节点树
       currentPage: 1,
       pageSize: 10,
       totalItems: 0,
      
    }
  },
  created() {
     if(util.session.get('roleId')=='4'){
      this.search.projectId = util.session.get('groupId')
    }else{
      this.search.projectId = util.session.get('proId')
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    // 搜索数据
    doFilter() {
      this.getData()
    },
    // 获取数据
    getData() {
      var that = this
      this.search.pageSize=this.pageSize,
      this.search.pageNum = this.currentPage,
      myHttp
        .getPageListdustOpLog(this.search)
        .then(
          function(resp) {
            if (resp.data.code == '200') {
             var  list=resp.data.data.pageInfo.list||[]
              for (var i = 0; i < list.length; i++) {
              list[i].index =
                that.pageSize * (parseInt(that.currentPage) - 1) + (i + 1)
            }
            that.listData = list
            that.totalItems=resp.data.data.pageInfo.total||0
            if(list.length==0){
              that.dataText = '暂无数据'
            }
            } else {
              that.$message.error(resp.data.msg)
              that.dataText = '暂无数据'
            }
          },
          function() {
            that.dataText = '服务器繁忙中，请稍后请求'
          }
        )
        },
    // //获取字典表
    // zidian() {
    //   var that = this
    //   myHttp
    //     .getDictByType({
    //       type: 'user_type'
    //     })
    //     .then(function(resp) {
    //       if (resp.data.code == '200') {
    //         var list = resp.data.data.dictList || []
            
    //       }
    //     })
    // },

    //点击树形结构
    handleNodeClick(data) {
      console.log(data)
      this.search.equipType = data.equipType
      this.getData()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.handleCurrentChange(this.currentPage)
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.currentChangePage()
    },
    // 监控当前页码
    currentChangePage(list) {
      this.getData()
    },
  
    
 

  
  }
}
</script>
<style>
/**
*图片放大右上角关闭按钮
*/
.el-image-viewer__close i{
    font-size: 4vh;
    color: #fff;
}
/* @import '../../assets/css/common.css'; */
</style>
<style scoped>
/* .content {
  height: 100%;
  width: 100%;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  padding: 1%;
} */
.grid-content {
  height: 2.5vh;
  font-size: 1.6vh;
}
.aside {
  box-shadow: rgba(8, 42, 51, 0.1) 0px 0px 7px 0px !important;
  border-radius: 10px !important;
  border: 0px !important;
  background-color: rgb(255, 255, 255);
}
/* .grid-search {
  display: flex;
  justify-content: space-between;
  margin: 0px 20px 0;
  height: 66px;
} */
.content >>> .el-card__body {
  padding: 0 !important;
  height: 100% !important;
}
.build-table {
  height: calc(100% - 160px);
}
.active {
  background: #409eff;
  color: #fff;
}
.contract-con {
  width: 100%;
  background: #fff;
  height: 125px;
  font-size: 14px;
}
.contract-con p {
  width: 100%;
  padding: 2px 20px;
  text-align: left;
}
.content >>> .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
  color: #4d95fd;
  font-weight: bold;
  padding: 10px 0px;
}
.content >>>.el-input-group--append .el-input__inner{
  width: 200px;
}
.content >>>.el-tree{
 padding:30px;
}
.grid-search{
  margin-right: 10px;
}
</style>